export const connectEruda = () => {
  const script = document.createElement('script');
  script.id = 'eruda';
  script.src = '//cdn.jsdelivr.net/npm/eruda';
  script.async = true;
  script.onload = () => {
    (window as any).eruda.init();
  };

  document.body.appendChild(script);
};

export const disconnectEruda = () => {
  if ((window as any).eruda) {
    (window as any).eruda.destroy();
  }

  const script = document.getElementById('eruda');
  if (script) {
    script.remove();
  }
};
